import * as React from "react";
import './components.css';

export type InputProps = {
  action?: React.ReactNode;
  disabled?: boolean;
  error?: string | boolean | null;
  id?: string;
  label: string;
  name?: string;
  type?: "text" | "email" | "password" | "date" | "tel";
  inputClass?:string;
  icon?: string;
  help?:string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rest?:any;
};

const Input2 = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { action, disabled, error, id, label, name, type = "text",inputClass="",icon,help,onChange,...rest},
) {
  return (
    <div className="mb-3">
        <label className="form-label" htmlFor={name}>{label}</label>
        <div style={{position: 'relative'}}>
        {icon && typeof icon === "string" && <i className={icon} style={{position:'absolute',top:'17px',left:'16px'}}></i>}
        <input {...rest} type={type} name={name} id={id} disabled={disabled}
          className={'form-control form-control-lg ' + inputClass + (error ? ' is-invalid':'')+(icon ? ' with-icon':'')} placeholder={label}
          onChange={(event) => onChange?.(event)} 
          // onInvalid={(e:React.ChangeEvent<HTMLInputElement>) => e.target.setCustomValidity('Enter User Name Here')} 
          // onInput={e => (e.target as HTMLInputElement).setCustomValidity('')}
        />
        {typeof error === "string" && <div className="invalid-feedback">{error}</div>}
        {action}
        {help && typeof help === "string" && <div className="help form-text">{help}</div>}
        </div>
    </div>
  );
});

export default Input2;
